var PhxCheckout = (function (PhxCheckout) {
    PhxCheckout.util = function () {
        function _getWindow() {
            return window;
        }
        return {
            getWindow: _getWindow
        };
    }();

    return PhxCheckout;
    
}(PhxCheckout || {}));

if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
    module.exports = PhxCheckout //export it as module only for jest.
}

